export default __webpack_public_path__ + "static/media/ksztalty-slim&fit.2f4ac81c.svg";